// GA4 conversion tracking. Never pass resume content, emails or other PII as params.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];

export const captureUtm = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_KEYS.forEach((k) => { const v = params.get(k); if (v) found[k] = v.slice(0, 120); });
    if (Object.keys(found).length) sessionStorage.setItem('utm_params', JSON.stringify(found));
  } catch (e) { /* ignore */ }
};

const utmParams = () => {
  try { return JSON.parse(sessionStorage.getItem('utm_params') || '{}'); } catch (e) { return {}; }
};

export const initAnalytics = () => {
  captureUtm();
  if (!GA_ID || window.gtag) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false });
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
};

export const trackPageView = (path) => {
  if (!window.gtag) return;
  window.gtag('event', 'page_view', { page_path: path, page_location: window.location.href, ...utmParams() });
};

export const track = (event, params = {}) => {
  if (!window.gtag) return;
  window.gtag('event', event, { ...params, ...utmParams() });
};
